import { render, staticRenderFns } from "./FileManagement.vue?vue&type=template&id=96e70a70&"
import script from "./FileManagement.vue?vue&type=script&lang=js&"
export * from "./FileManagement.vue?vue&type=script&lang=js&"
import style0 from "./FileManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96e70a70')) {
      api.createRecord('96e70a70', component.options)
    } else {
      api.reload('96e70a70', component.options)
    }
    module.hot.accept("./FileManagement.vue?vue&type=template&id=96e70a70&", function () {
      api.rerender('96e70a70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/FileManagement.vue"
export default component.exports